/* global IntelliSuggest*/
define('SearchSpring.Tracker', [
    'SC.Configuration',
    'Tracker',
    'jQuery'
], function SearchSpringTracker(
    Configuration,
    Tracker,
    jQuery
) {
    var trackingSearchSpring = {
        scriptLoadStarted: false,
        scriptPromise: null,
        runAfterIntelliSuggest: function runAfterIntelliSuggest(runFn) {
            if (typeof IntelliSuggest !== 'undefined') {
                runFn();
                return;
            }
            this.loadScript();
            if (this.scriptPromise && typeof this.scriptPromise.done === 'function') {
                this.scriptPromise.done(runFn);
            }
        },
        trackProductView: function trackProductView(model) {
            this.runAfterIntelliSuggest(function runProductView() {
                var productCode;
                var ssInit;
                var item;
                try {
                    item = model.get('item');
                    productCode = item.get('_sku');
                    ssInit = {
                        siteId: Configuration.get('searchspring.siteId'),
                        context: 'Product/' + productCode,
                        seed: [productCode]
                    };
                    IntelliSuggest.init(ssInit);
                    IntelliSuggest.viewItem({ sku: productCode });
                } catch (err) {
                    // SearchSpring tracking failed; avoid console in production
                }
            });
        },
        trackViewCart: function trackViewCart(cart) {
            this.runAfterIntelliSuggest(function runViewCart() {
                var cartLines;
                var productsSkus;
                var ssInit;
                try {
                    cartLines = cart.get('lines');
                    productsSkus = [];

                    cartLines.each(function eachCartLine(line) {
                        productsSkus.push(line.get('item').get('_sku'));
                    });

                    ssInit = {
                        siteId: Configuration.get('searchspring.siteId'),
                        context: 'Basket',
                        seed: productsSkus
                    };

                    IntelliSuggest.init(ssInit);

                    cartLines.each(function eachCartLine(line) {
                        var item = line.get('item');
                        var ssItem = {
                            sku: item.get('_sku'),
                            qty: line.get('quantity'),
                            price: item.get('_price')
                        };
                        IntelliSuggest.haveItem(ssItem);
                    });

                    IntelliSuggest.inBasket({});
                } catch (e) {
                    // SearchSpring cart tracking failed
                }
            });
        },
        trackTransaction: function trackTransaction(transaction) {
            this.runAfterIntelliSuggest(function runTransaction() {
                var inSale = {
                    orderId: transaction.get('confirmationNumber'),
                    total: transaction.get('total'),
                    country: 'US'
                };
                try {
                    IntelliSuggest.init({
                        siteId: Configuration.get('searchspring.siteId')
                    });
                    transaction.get('products').each(function eachProduct(product) {
                        var searchSpringProductLine = {
                            sku: product.get('id'),
                            qty: product.get('quantity'),
                            price: product.get('rate')
                        };
                        IntelliSuggest.haveItem(searchSpringProductLine);
                    });

                    IntelliSuggest.inSale(inSale);
                } catch (err) {
                    // SearchSpring sale tracking failed
                }
            });
        },
        loadScript: function loadScript() {
            if (this.scriptLoadStarted) {
                return this.scriptPromise;
            }
            this.scriptLoadStarted = true;
            this.scriptPromise = jQuery.getScript('//cdn.searchspring.net/intellisuggest/is.min.js');
            return this.scriptPromise;
        },
        scheduleDeferredLoad: function scheduleDeferredLoad() {
            var self = this;
            var startLoad = function startLoad() {
                self.loadScript();
            };
            if (typeof window !== 'undefined' && window.requestIdleCallback) {
                window.requestIdleCallback(startLoad, { timeout: 5000 });
            } else if (typeof window !== 'undefined' && window.setTimeout) {
                window.setTimeout(startLoad, 2000);
            } else {
                startLoad();
            }
        },
        mountToApp: function mountToApp(application) {
            var layout = application.getLayout();
            if (!SC.isPageGenerator()) {
                layout.on('afterAppendView', function onAfterAppendView(view) {
                    // eslint-disable-next-line default-case
                    switch (view && view.template && view.template.Name) {
                    case 'cart_detailed':
                        trackingSearchSpring.trackViewCart(view.model);
                        break;
                    }
                });

                Tracker.getInstance().trackers.push(trackingSearchSpring);
                this.scheduleDeferredLoad();
            }
        }
    };

    return trackingSearchSpring;
});
